import edap from '@homeaway/edap-wrapper';

// EDAP EVENTS
export const TRIP_PAYMENT_SET_PRESENTED = 'trip_payment_set.presented';

// ACTION LOCATIONS
export const TRIP_PAYMENTS = 'trip_payments';

export const triggerEdap = (name, data) => {
    edap().push({
        name,
        data,
    });
};

export const tripPaymentSetPresented = ({actionLocation, reservationUUID}) => {
    triggerEdap(TRIP_PAYMENT_SET_PRESENTED, {
        action_location: actionLocation,
        reservation_id: reservationUUID,
    });
};
